// extracted by mini-css-extract-plugin
export default {"section":"form-cards_section__efgC4","wrapper":"form-cards_wrapper__nTbQu","title":"form-cards_title__5i34S","card":"form-cards_card__4obPQ"};